// Wrapper for rich-text editing.
//
// It currently delegates to document.execCommand, which is soft-deprecated (flagged in lib.dom, but still shipped by
// every browser and the only built-in way to edit a contenteditable). Keeping every call here means that, if the API
// is ever removed, only the bodies below change - callers stay untouched.
//
// The deprecation lives behind this untagged accessor so it doesn't flag each call.
const editor = document as unknown as {
  execCommand(command: string, showUI?: boolean, value?: string): boolean;
  queryCommandState(command: string): boolean;
  queryCommandValue(command: string): string;
};

// Apply an inline style or list command: bold, italic, underline, strikeThrough, insertUnorderedList, insertOrderedList.
// Forces semantic tags (<b>, <ul>, etc.) rather than inline styles so the slide CSS applies and toggling off is clean.
export function formatSelection(command: string): void {
  editor.execCommand("styleWithCSS", false, "false");
  editor.execCommand(command, false);
}

// Apply a text color to the selection, or set the typing color at a collapsed caret.
export function colorSelection(color: string): void {
  editor.execCommand("styleWithCSS", false, "true");
  editor.execCommand("foreColor", false, color);
  editor.execCommand("styleWithCSS", false, "false");
}

// Whether a command is active at the caret/selection (toolbar button state).
export function isCommandActive(command: string): boolean {
  return editor.queryCommandState(command);
}

// Current text color at the caret as #rrggbb (for the toolbar swatch).
export function currentColor(): string | null {
  return rgbToHex(editor.queryCommandValue("foreColor"));
}

function rgbToHex(value: string): string | null {
  if (!value) {
    return null;
  }
  if (value.startsWith("#")) {
    return value;
  }
  const match = value.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
  if (!match) {
    return null;
  }
  const toHex = (n: string) => parseInt(n, 10).toString(16).padStart(2, "0");
  return `#${toHex(match[1])}${toHex(match[2])}${toHex(match[3])}`;
}
